export var BasicColumnTypes;

(function (BasicColumnTypes) {
  BasicColumnTypes["Currency"] = "currency";
  BasicColumnTypes["Date"] = "date";
  BasicColumnTypes["Period"] = "period";
  BasicColumnTypes["Year"] = "year";
  BasicColumnTypes["YearInterval"] = "yearInterval";
  BasicColumnTypes["DayInterval"] = "dayInterval";
  BasicColumnTypes["Numeric"] = "numeric";
  BasicColumnTypes["Percent"] = "percentage";
  BasicColumnTypes["Text"] = "text";
})(BasicColumnTypes || (BasicColumnTypes = {}));